/* eslint-disable jsx-a11y/img-redundant-alt */
import { Box, Button, Grid, Typography } from "@mui/material";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import DownloadIcon from "@mui/icons-material/Download";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UPS from "../../../assets/images/upsimage.png";
import QR from "../../../assets/images/qrcode.png";
import PersonIcon from "@mui/icons-material/Person";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import Inventory2Icon from "@mui/icons-material/Inventory2";

const copies = [
  {
    type: "CUSTOMER COPY",
    icon: PersonIcon,
    sender: {
      type: "Sender",
      name: "John Doe",
      phone: "+1 234-567-8900",
      email: "jhn@gmail.com",
      address: "123 Sender St, City, State 12345",
    },
    receiver: {
      type: "Receiver",
      name: "Jane Smith",
      phone: "+1 234-567-8900",
      email: "janesmith@gmail.com",
      address: "123 Sender St, City, State 12345",
    },
    shipment: {
      service: "USPS International Express",
      amountPaid: "$125.00",
      transitTime: "3-5 Business Days",
      paymentMethod: "Store Agent",
      confirmationId: "POST123456789",
      barcodeLabel: "POST123456789",
    },
  },
  {
    type: "STORE COPY",
    icon: StoreMallDirectoryIcon,
    sender: {
      type: "Sender",
      name: "John Doe",
      phone: "+1 234-567-8900",
      email: "jhn@gmail.com",
      address: "123 Sender St, City, State 12345",
    },
    receiver: {
      type: "Receiver",
      name: "Jane Smith",
      phone: "+1 234-567-8900",
      email: "janesmith@gmail.com",
      address: "123 Sender St, City, State 12345",
    },
    shipment: {
      service: "USPS International Express",
      amountPaid: "$125.00",
      transitTime: "3-5 Business Days",
      paymentMethod: "Store Agent",
      confirmationId: "POST123456789",
      barcodeLabel: "POST123456789",
    },
  },
  {
    type: "PACKAGE SLIP",
    icon: Inventory2Icon,
    sender: {
      type: "Sender",
      name: "John Doe",
      phone: "+1 234-567-8900",
      email: "jhn@gmail.com",
      address: "123 Sender St, City, State 12345",
    },
    receiver: {
      type: "Receiver",
      name: "Jane Smith",
      phone: "+1 234-567-8900",
      email: "janesmith@gmail.com",
      address: "123 Sender St, City, State 12345",
    },
    shipment: {
      service: "USPS International Express",
      amountPaid: "$125.00",
      transitTime: "3-5 Business Days",
      paymentMethod: "Store Agent",
      confirmationId: "POST123456789",
      barcodeLabel: "POST123456789",
    },
  },
];

function Payment({ setPaymentToggal, paymentToggal }) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: "700",
            fontSize: "28px",
            lineHeight: "120%",
            letterSpacing: "0px",
          }}
        >
          <span>
            <CheckCircleIcon sx={{ color: "#38A34F", fontSize: "28px" }} />
          </span>
          Payment Successful!
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            onClick={() => setPaymentToggal(!paymentToggal)}
            sx={{
              flex: 1,
              backgroundColor: "#481AA3",
              color: "#fff",
              border: "1px solid #5E17EB",
              boxShadow: "none",
              marginBottom: "10px",
              borderRadius: "4px",
              whiteSpace: "nowrap",
              mr: 1,
              "&:hover": {
                outline: "none",
                color: "#fff",
                backgroundColor: "#481AA3",
              },
            }}
          >
            <span>
              <LocalPrintshopIcon />
            </span>
            <span
              style={{
                fontWeight: "600",
                fontSize: "16px",
                lineHeight: "120%",
                letterSpacing: "0px",
              }}
            >
              Print All Slips
            </span>
          </Button>

          <Button
            variant="contained"
            onClick={() => setPaymentToggal(!paymentToggal)}
            sx={{
              flex: 1,
              backgroundColor: "white",
              color: "black",
              border: "1px solid black",
              boxShadow: "none",
              marginBottom: "10px",
              borderRadius: "4px",
              whiteSpace: "nowrap",
              "&:hover": {
                outline: "none",
                color: "black",
                backgroundColor: "white",
              },
            }}
          >
            <span>
              <DownloadIcon />
            </span>
            <span
              style={{
                fontWeight: "600",
                fontSize: "16px",
                lineHeight: "120%",
                letterSpacing: "0px",
              }}
            >
              Download PDF
            </span>
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "3rem",
          justifyContent: "center",
          mt: 3,
        }}
      >
        {copies.map((item) => {
          return (
            <Box
              sx={{
                border: "1px solid #E5E5E8",
                width: "30%",
                borderRadius: "12px",
                height: "77vh",
              }}
            >
              <Box
                sx={{
                  borderBottom: "1px solid #E5E5E8",
                }}
              >
                <Box
                  sx={{
                    marginX: "1.5rem",
                    marginY: "10px",
                    display: "flex",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                    gap: "7px",
                  }}
                >
                  <Box>
                    <item.icon sx={{ color: "#959BA1" }} />
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontStyle: "bold",
                      fontSize: "17px",
                      lineHeight: "120%",
                      letterSpacing: "0px",
                    }}
                  >
                    {item.type}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  borderBottom: "1px solid #E5E5E8",
                }}
              >
                <Box
                  sx={{
                    marginX: "1.5rem",
                    marginY: "2rem",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item>
                      <Typography>
                        <span
                          style={{
                            marginTop: "10px",
                            marginBottom: "10px",
                            fontFamily: "Roboto Mono",
                            fontWeight: "700",
                            fontStyle: "bold",
                            fontSize: "14px",
                            lineHeight: "120%",
                            letterSpacing: "0px",
                          }}
                        >
                          {item.sender.type}
                        </span>
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Grid container direction="column">
                        <Grid item>
                          <span
                            style={{
                              fontFamily: "Roboto Mono",
                              fontWeight: "700",
                              fontStyle: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.sender.name}
                          </span>
                        </Grid>
                        <Grid item>
                          <span
                            style={{
                              fontFamily: "Roboto Mono",
                              fontWeight: "700",
                              fontStyle: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.sender.phone}
                          </span>
                        </Grid>
                        <Grid item>
                          <span
                            style={{
                              fontFamily: "Roboto Mono",
                              fontWeight: "700",
                              fontStyle: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.sender.email}
                          </span>
                        </Grid>
                        <Grid item>
                          <span
                            style={{
                              fontFamily: "Roboto Mono",
                              fontWeight: "700",
                              fontStyle: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.sender.address}
                          </span>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  borderBottom: "1px solid #E5E5E8",
                }}
              >
                <Box
                  sx={{
                    marginX: "1.5rem",
                    marginY: "2rem",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item>
                      <Typography>
                        <span
                          style={{
                            marginTop: "10px",
                            marginBottom: "10px",
                            fontFamily: "Roboto Mono",
                            fontWeight: "700",
                            fontStyle: "bold",
                            fontSize: "14px",
                            lineHeight: "120%",
                            letterSpacing: "0px",
                          }}
                        >
                          {item.receiver.type}
                        </span>
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Grid container direction="column">
                        <Grid item>
                          <span
                            style={{
                              fontFamily: "Roboto Mono",
                              fontWeight: "700",
                              fontStyle: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.receiver.name}
                          </span>
                        </Grid>
                        <Grid item>
                          <span
                            style={{
                              fontFamily: "Roboto Mono",
                              fontWeight: "700",
                              fontStyle: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.receiver.phone}
                          </span>
                        </Grid>
                        <Grid item>
                          <span
                            style={{
                              fontFamily: "Roboto Mono",
                              fontWeight: "700",
                              fontStyle: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.receiver.email}
                          </span>
                        </Grid>
                        <Grid item>
                          <span
                            style={{
                              fontFamily: "Roboto Mono",
                              fontWeight: "700",
                              fontStyle: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.receiver.address}
                          </span>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 2,
                  borderBottom: "1px solid #E5E5E8",
                }}
              >
                <Box
                  sx={{
                    marginX: "1.5rem",
                    marginY: "10px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      alignItems: "center",
                      marginY: "1.5rem",
                    }}
                  >
                    <span>
                      <img src={UPS} alt="image" width={24} height={24} />
                    </span>
                    <Typography
                      sx={{
                        fontFamily: "",
                        fontWeight: "700",
                        fontStyle: "bold",
                        fontSize: "14px",
                        lineHeight: "120%",
                        letterSpacing: "0px",
                      }}
                    >
                      {item.shipment.service}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      marginY: "1.5rem",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: "10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontStyle: "bold",
                        fontSize: "14px",
                        lineHeight: "120%",
                        letterSpacing: "0px",
                      }}
                    >
                      Amount Paid: <br />
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontStyle: "bold",
                          fontSize: "14px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        {item.shipment.amountPaid}
                      </Typography>
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "",
                        fontWeight: "400",
                        fontStyle: "bold",
                        fontSize: "14px",
                        lineHeight: "120%",
                        letterSpacing: "0px",
                      }}
                    >
                      Transit Time: <br />
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontStyle: "bold",
                          fontSize: "14px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        {item.shipment.transitTime}
                      </Typography>
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      marginY: "1.5rem",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: "10px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontStyle: "bold",
                        fontSize: "14px",
                        lineHeight: "120%",
                        letterSpacing: "0px",
                      }}
                    >
                      Payment method: <br />
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontStyle: "bold",
                          fontSize: "14px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        {item.shipment.paymentMethod}
                      </Typography>
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "",
                        fontWeight: "400",
                        fontStyle: "bold",
                        fontSize: "14px",
                        lineHeight: "120%",
                        letterSpacing: "0px",
                        mr: "1rem",
                      }}
                    >
                      Confirmation ID: <br />
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontStyle: "bold",
                          fontSize: "14px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                        }}
                      >
                        {item.shipment.confirmationId}
                      </Typography>
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 3,
                }}
              >
                <Box
                  sx={{
                    marginX: "1.5rem",
                    marginY: "10px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <span>
                      <img src={QR} alt="image" width={210} height={80} />
                    </span>
                    <Typography
                      sx={{
                        fontFamily: "",
                        fontWeight: "700",
                        fontStyle: "bold",
                        fontSize: "14px",
                        lineHeight: "120%",
                        letterSpacing: "0px",
                      }}
                    >
                      Receiving ID: {item.shipment.barcodeLabel}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </>
  );
}

export default Payment;
